import i18next from 'i18next';

import { authInstance } from '../firebase';
import { deleteLocalAndSessionStorageAndCookies } from './cache';
import * as segment from './segment';
import { clearScribeConversationState, firebaseLogout, toggleSideBar } from '../actions';

export const HEARING_PROFILES = {
  // $FlowFixMe
  0: 'hearingProfile.deaf',
  // $FlowFixMe
  1: 'hearingProfile.hardOfHearing',
  // $FlowFixMe
  2: 'hearingProfile.hearing',
};

export const getDisplayName = user => {
  return user.userName || user.displayName || user.username;
};

export const isUserNameValid = userName => {
  return userName.trim().length >= 2 && userName.trim().length < 50;
};

export const getAvaName = user => {
  return user.avaName;
};

export const getDisplayId = (user, t) => {
  if (user.emails) {
    return Array.from(Object.values(user.emails))[0];
  }
  if (user.phoneNumber) {
    return user.phoneNumber;
  }
  if (user.accountType === 'Temporary') {
    return t('temporaryAccount');
  }
  return user.uid || user.id;
};

export const getHearingProfile = user => user.profile.hearingProfile;

export const getUserColor = username => {
  if (!username) {
    return 'grey';
  }
  let hash = 0;
  username.split('').forEach(c => {
    // eslint-disable-next-line
    hash = c.charCodeAt(0) + ((hash << 5) - hash);
  });
  const h = hash % 360;
  // eslint-disable-next-line
  return 'hsl(' + h + ', ' + 50 + '%, ' + 50 + '%)';
};

export const isDevMode = (currentPlatform, features, backends) => {
  return (
    !!features['dev-mode'] ||
    (currentPlatform === 'web' && localStorage.getItem('avaBackendUrl') === backends.production.url)
  );
};

export const logoutAndClean = async () => {
  if (authInstance.currentUser && authInstance.currentUser.isAnonymous) {
    await authInstance.currentUser.delete();
  }
  segment.track('Signed Out');
  segment.reset();
  await authInstance.signOut();
  deleteLocalAndSessionStorageAndCookies();

  window.store.dispatch(clearScribeConversationState());
  window.store.dispatch(firebaseLogout());
  window.store.dispatch(toggleSideBar(false));

  if (window.electronIPC) {
    window.electronIPC.sendSetIsLoggedIn(false);
  }
};

if (window.electronIPC) {
  window.electronIPC.onSignOutAndShowSignIn(async () => {
    await logoutAndClean();
    if (window.browserHistory) {
      window.browserHistory.push('/web/login');
    } else {
      window.history.pushState({}, document.title, '/web/login');
      window.location.reload();
    }
  });
}
